import { apiClient } from '@shared/utils/api-client';
import type { ApplicationDetailShape } from '@modules/seller-applications/components/ApplicationDetailFields';

export type SellerAccountBlockReasonDto =
  | 'RUDE_CUSTOMER_CONTACT'
  | 'FAKE_ORDERS'
  | 'SYSTEMATIC_RULE_VIOLATION'
  | 'REPEATED_INACTION_ORDER_AUTO_CANCEL'
  | 'REPEATED_LOW_RATING_ORDERS';

export interface SellerAccountBlockDto {
  reason: SellerAccountBlockReasonDto;
  comment: string | null;
  blockedAt: string;
  blockedUntil: string | null;
  permanent: boolean;
  awaitingManualReview: boolean;
}

export interface SellerProfileDeletionDto {
  requestedAt: string;
  scheduledAt: string;
  deletedAt?: string;
}

export interface SellerListItem {
  id: number;
  shopName: string;
  slug: string;
  createdAt: string;
  updatedAt: string;
  profileHidden?: boolean;
  profileDeletion?: SellerProfileDeletionDto | null;
  application: (ApplicationDetailShape & { id: number }) | null;
  _count: { products: number; pickupPoints: number };
  accountBlock?: SellerAccountBlockDto | null;
}

export interface SellerDetail extends SellerListItem {
  application:
    | (ApplicationDetailShape & {
        id: number;
        moderatedBy: { id: number; email: string; name: string | null } | null;
      })
    | null;
  /** Общий рейтинг магазина: среднее по рейтингам одобренных видимых товаров */
  averageRating?: number | null;
  /** Число отзывов, из которых сложился рейтинг магазина */
  approvedReviewCount?: number;
  accountBlock?: SellerAccountBlockDto | null;
}

export const sellersApi = {
  getAll: (search?: string) => {
    const q = search?.trim();
    return apiClient.get<SellerListItem[]>(
      q ? `/sellers?search=${encodeURIComponent(q)}` : '/sellers',
    );
  },
  getById: (id: number) => apiClient.get<SellerDetail>(`/sellers/${id}`),
  accountBlock: (sellerId: number, body: { reason: SellerAccountBlockReasonDto; comment?: string }) =>
    apiClient.post<SellerDetail>(`/sellers/${sellerId}/account-block`, body),
  accountUnblock: (sellerId: number) =>
    apiClient.post<SellerDetail>(`/sellers/${sellerId}/account-unblock`, {}),
};
